import React, { memo } from "react";
import { Button, type ButtonProps } from "@chakra-ui/react";

export type PublicActionButtonTone = "primary" | "secondary";

export type PublicActionButtonProps = Omit<ButtonProps, "children"> & {
  children: React.ReactNode;
  tone?: PublicActionButtonTone;
};

const PUBLIC_ACTION_BUTTON_TONES = {
  primary: {
    bg: "moveon.primary",
    color: "moveon.public.surface.base",
    hoverBg: "moveon.primaryLight",
    hoverColor: "moveon.primary",
  },
  secondary: {
    bg: "moveon.secondary",
    color: "moveon.public.surface.base",
    hoverBg: "moveon.secondaryLight",
    hoverColor: "moveon.secondary",
  },
} as const;

const PUBLIC_ACTION_BUTTON_FOCUS_PROPS = {
  outlineWidth: "2",
  outlineStyle: "solid",
  outlineColor: "moveon.primary",
  outlineOffset: "2px",
} as const;

function PublicActionButton({
  children,
  tone = "primary",
  borderRadius = "md",
  ...buttonProps
}: PublicActionButtonProps) {
  const toneProps = PUBLIC_ACTION_BUTTON_TONES[tone];

  return (
    <Button
      borderRadius={borderRadius}
      bg={toneProps.bg}
      color={toneProps.color}
      _hover={{
        bg: toneProps.hoverBg,
        color: toneProps.hoverColor,
      }}
      _focusVisible={PUBLIC_ACTION_BUTTON_FOCUS_PROPS}
      {...buttonProps}
    >
      {children}
    </Button>
  );
}

export default memo(PublicActionButton);
